import { ArrowTopRightOnSquareIcon, PencilIcon, WrenchScrewdriverIcon } from "@heroicons/react/24/outline";
import classNames from "../../../../utils/classNames";
import PriceFormat from "../../../../utils/priceFormat";
import CompactEditableValue from "./CompactEditableValue";
import CurrencyInput from "./CurrencyInput";

export default function EngineEstimateTile({
  value,
  ebayUrl,
  hasOverride,
  mainEditing,
  mainInputValue,
  onMainInputChange,
  onMainStartEdit,
  onMainSave,
  onMainCancel,
  ewwValue,
  ewwEditing,
  onEwwStartEdit,
  onEwwSave,
  vlaValue,
  vlaEditing,
  onVlaStartEdit,
  onVlaSave,
  sourceInputValue,
  onSourceInputChange,
  onSourceCancel,
}: {
  value: number | null;
  ebayUrl: string;
  hasOverride: boolean;
  mainEditing: boolean;
  mainInputValue: string;
  onMainInputChange: (value: string) => void;
  onMainStartEdit: () => void;
  onMainSave: () => void;
  onMainCancel: () => void;
  ewwValue: number | null;
  ewwEditing: boolean;
  onEwwStartEdit: () => void;
  onEwwSave: () => void;
  vlaValue: number | null;
  vlaEditing: boolean;
  onVlaStartEdit: () => void;
  onVlaSave: () => void;
  sourceInputValue: string;
  onSourceInputChange: (value: string) => void;
  onSourceCancel: () => void;
}) {
  return (
    <div
      className={classNames(
        "rounded-lg border p-3 transition-colors",
        hasOverride ? "border-blue-200 bg-blue-50/50" : "border-gray-200 bg-gray-50"
      )}
    >
      <div className="mb-1 flex items-center gap-1.5">
        <span className="shrink-0 text-blue-500">
          <WrenchScrewdriverIcon className="h-3.5 w-3.5" />
        </span>
        <span className="flex-1 text-[10px] font-semibold uppercase tracking-wider leading-tight text-gray-500">
          Engine Price
        </span>

        <a
          href={ebayUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="shrink-0 rounded p-0.5 text-gray-400 transition-colors hover:bg-blue-50 hover:text-blue-600"
          title="Search eBay for engine price"
        >
          <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5" />
        </a>

        {!mainEditing && (
          <button
            type="button"
            onClick={onMainStartEdit}
            className="shrink-0 rounded p-0.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-primary-600"
            title="Edit engine price"
          >
            <PencilIcon className="h-3 w-3" />
          </button>
        )}
      </div>

      {mainEditing ? (
        <div className="mb-1.5">
          <CurrencyInput
            value={mainInputValue}
            onChange={onMainInputChange}
            onSave={onMainSave}
            onCancel={onMainCancel}
            inputClassName="w-full rounded border border-primary-300 px-1.5 py-0.5 text-sm font-bold text-gray-900 focus:border-primary-500 focus:ring-primary-500"
            saveIconClassName="h-3.5 w-3.5"
          />
        </div>
      ) : (
        <p className="mb-1.5 text-sm font-bold text-gray-900">
          {value != null ? (
            PriceFormat(value)
          ) : (
            <button
              type="button"
              onClick={onMainStartEdit}
              className="text-gray-400 underline decoration-dashed underline-offset-2 transition-colors hover:text-primary-600"
            >
              Add price
            </button>
          )}
        </p>
      )}

      <div className="space-y-0.5 border-t border-gray-200 pt-1.5">
        <CompactEditableValue
          label="EWW"
          value={ewwValue}
          isEditing={ewwEditing}
          inputValue={sourceInputValue}
          onInputChange={onSourceInputChange}
          onStartEdit={onEwwStartEdit}
          onSave={onEwwSave}
          onCancel={onSourceCancel}
        />

        <CompactEditableValue
          label="VLA"
          value={vlaValue}
          isEditing={vlaEditing}
          inputValue={sourceInputValue}
          onInputChange={onSourceInputChange}
          onStartEdit={onVlaStartEdit}
          onSave={onVlaSave}
          onCancel={onSourceCancel}
        />
      </div>
    </div>
  );
}